import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-m', 'LetterM', [["path",{"d":"M8 17V7l3.75 5 3.75-5v10","key":"svg-0"}]]);